import { cn } from '@/lib/utils/tailwind';

import type { CardContainerProps } from './types';

export const Footer = ({ className = '', children }: CardContainerProps) => (
  <div className={cn('mt-4', className)}>{children}</div>
);
